// Version Upgrade Check-Related Functionality

const CHECK_FOR_VERSION_UPDATE_INTERVAL = 60/*min*/ * 60/*sec/min*/ * 1000/*ms/sec*/;

function cbHandleVersionResponse(version, _unused_locale) {
    if ( ar.state.version && (version !== ar.state.version) ) {
        if ( ar.state.versionIntervalTimer ) {
            clearVersionIntervalTimer();
        }
        if ( window.location.pathname !== '/new-version' ) {
            arRouter.push('/new-version');
        }
    }
}

function checkForVersionUpdate() {
	ar.getVersion(cbHandleVersionResponse);
}

function clearVersionIntervalTimer() {
    if ( ar.state.versionIntervalTimer ) {
        clearInterval(ar.state.versionIntervalTimer);
    }
    ar.setState({
        versionIntervalTimer: null
    });
}

function setVersionIntervalTimer() {
    if ( ar.state.versionIntervalTimer ) {
        clearInterval(ar.state.versionIntervalTimer);
    }
    const interval = setInterval(checkForVersionUpdate, CHECK_FOR_VERSION_UPDATE_INTERVAL);
	ar.setState({ versionIntervalTimer: interval });
}

export {
    clearVersionIntervalTimer,
    setVersionIntervalTimer
}
